import { useNavigate } from 'react-router-dom';
import { PrimaryTextColor } from '../../../app/theme/tokens/colors';
import { PrimaryButton, SecondaryButton } from '../../../shared/ui/Inputs';
import { LargeTile } from '../../../shared/ui/grid/gridsystem';
import { WideLayout } from '../../../shared/layout/widelayout';
import { Panel } from '../../../shared/ui/panel/panels';
import { OrderFlowPageHeader } from '../../../shared/ui/orderFlowPageHeader';
import { useRechargeStore } from '../store/rechargeStore';
import { GiHandTruck } from 'react-icons/gi';
import { ExchangeIcon } from '../../../shared/icons/ExchangeIcon';

const MainPanels = () => {
  const selectedPatient = useRechargeStore((state) => state.selectedPatient);
  const rechargerActions = useRechargeStore((state) => state.rechargerActions);
  const selectedPatientIndex = useRechargeStore(
    (state) => state.selectedPatientIndex
  );
  const navigate = useNavigate();
  const operations =
    rechargerActions &&
    selectedPatientIndex !== undefined &&
    selectedPatientIndex !== null
      ? rechargerActions[selectedPatientIndex] ?? {}
      : {};

  const operationValues = Object.values(operations ?? {});
  const hasAnyOperation = operationValues.length > 0;

  const formatVolume = (raw) => {
    if (raw === null || raw === undefined || raw === '') return '-';
    const s = String(raw).trim();
    if (!s) return '-';
    const normalized = s.replace('m3', 'm³').replace('m³', '').trim();
    const asNumber = Number(normalized.replace(',', '.'));
    const text = Number.isFinite(asNumber)
      ? String(asNumber).replace('.', ',')
      : normalized;
    return `${text} m³`;
  };

  const hasCylinderToChange =
    operationValues.filter(
      (x) => x?.action === 'troca' && x?.newCylinder !== undefined
    ).length > 0;
  const hasCylinderToRecharge =
    operationValues.filter(
      (x) => x?.action === 'recarga' && (x?.quantity ?? 0) > 0
    ).length > 0;

  if (!selectedPatient) {
    return (
      <>
        <LargeTile margin={'15px'}>
          <OrderFlowPageHeader
            title="Recarga"
            subtitle="Confirme os cilindros solicitados."
          />
          <Panel style={{ padding: '20px' }}>
            <div style={{ color: PrimaryTextColor, marginBottom: '15px' }}>
              Não foi possível carregar o paciente selecionado. Volte e
              selecione novamente.
            </div>
            <SecondaryButton
              onClick={() =>
                navigate('/recharge/rechargePatient?keepState=true')
              }
            >
              Voltar
            </SecondaryButton>
          </Panel>
        </LargeTile>
      </>
    );
  }

  if (!hasAnyOperation) {
    return (
      <>
        <LargeTile margin={'15px'}>
          <OrderFlowPageHeader
            title="Recarga"
            subtitle={`Confirme os cilindros solicitados para ${selectedPatient.name}.`}
          />
          <Panel style={{ padding: '20px' }}>
            <div style={{ color: PrimaryTextColor, marginBottom: '15px' }}>
              Não foi possível carregar as operações de recarga. Volte e
              selecione novamente.
            </div>
            <SecondaryButton
              onClick={() =>
                navigate('/recharge/rechargePatient?keepState=true')
              }
            >
              Voltar
            </SecondaryButton>
          </Panel>
        </LargeTile>
      </>
    );
  }
  return (
    <>
      <LargeTile margin={'15px'}>
        <OrderFlowPageHeader
          title="Recarga"
          subtitle={`Confirme os cilindros solicitados para ${selectedPatient.name}.`}
        />
        <Panel style={{ padding: '20px' }}>
          <div style={{ overflow: 'auto', color: PrimaryTextColor }}>
            {operationValues.filter(
              (x) => x?.action === 'troca' && x?.newCylinder !== undefined
            ).length > 0 ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: 'solid 1px #ccc',
                  marginBottom: '5px',
                  marginTop: '10px',
                }}
              >
                <ExchangeIcon height="30px"></ExchangeIcon>
                <div
                  style={{
                    fontSize: '16px',
                    color: '#000',
                    margin: 'auto 0px auto 5px',
                  }}
                >
                  Cilindros que serão trocado
                </div>
              </div>
            ) : (
              <></>
            )}
            <ul style={{ margin: '0px', padding: '0px' }}>
              {operationValues
                .filter(
                  (x) => x?.action === 'troca' && x?.newCylinder !== undefined
                )
                .map((x, idx) => (
                  <li
                    style={{
                      listStyle: 'none',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '10px',
                      padding: '6px 15px',
                      background: '#efefef',
                      borderRadius: '10px',
                      marginBottom: '5px',
                      color: '#000',
                    }}
                    key={idx}
                  >
                    <div
                      style={{
                        flex: 1,
                        minWidth: 0,
                        fontSize: '14px',
                        wordBreak: 'break-word',
                      }}
                    >
                      <div>
                        {(() => {
                          const fromVol = formatVolume(x?.cylinder?.size);
                          const fromVolSuffix =
                            fromVol && fromVol !== '-' ? ` (${fromVol})` : '';
                          return (
                            <>
                              <span>Troca de </span>
                              <span>
                                {(x?.cylinder?.product ?? '-') + fromVolSuffix}
                              </span>
                              <span> para </span>
                              <span>{x?.newCylinder?.description ?? '-'}</span>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                    <div
                      style={{ fontSize: '14px', whiteSpace: 'nowrap' }}
                    >{`Volume: ${formatVolume(
                      x?.newCylinder?.size
                    )} | Quantidade: ${x?.quantity ?? 1}`}</div>
                  </li>
                ))}
            </ul>
            {operationValues.filter(
              (x) => x?.action === 'recarga' && (x?.quantity ?? 0) > 0
            ).length > 0 ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: 'solid 1px #ccc',
                  marginBottom: '5px',
                  marginTop: '10px',
                }}
              >
                <GiHandTruck
                  style={{
                    fontSize: '30px',
                    marginRight: '9px',
                    color: '#318300',
                  }}
                ></GiHandTruck>
                <div style={{ fontSize: '16px', color: '#000' }}>
                  Cilindros que serão recarregados
                </div>
              </div>
            ) : (
              <></>
            )}
            <ul style={{ margin: '0px', padding: '0px' }}>
              {operationValues
                .filter(
                  (x) => x?.action === 'recarga' && (x?.quantity ?? 0) > 0
                )
                .map((x, idx) => (
                  <li
                    style={{
                      listStyle: 'none',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '10px',
                      padding: '6px 15px',
                      background: '#efefef',
                      borderRadius: '10px',
                      marginBottom: '5px',
                      color: '#000',
                    }}
                    key={idx}
                  >
                    <div
                      style={{ flex: 1, minWidth: 0, wordBreak: 'break-word' }}
                    >
                      {x?.cylinder?.product}
                    </div>
                    <div
                      style={{ whiteSpace: 'nowrap' }}
                    >{`Volume: ${formatVolume(
                      x?.cylinder?.size
                    )} | Quantidade: ${x?.quantity ?? 1}`}</div>
                  </li>
                ))}
            </ul>
          </div>
          <div
            style={{
              marginTop: '50px',
              display: 'inline-grid',
              width: '100%',
              boxSizing: 'border-box',
              gridTemplateColumns: 'repeat(auto-fit, 300px)',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <SecondaryButton
                onClick={() =>
                  navigate('/recharge/rechargePatient?keepState=true')
                }
              >
                Voltar
              </SecondaryButton>
            </div>
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <SecondaryButton
                style={{ marginRight: '10px' }}
                onClick={() => navigate('/orders')}
              >
                Cancelar
              </SecondaryButton>
              <PrimaryButton
                disabled={!hasCylinderToChange && !hasCylinderToRecharge}
                onClick={() => {
                  navigate('/recharge/finishRecharge');
                }}
              >
                Prosseguir
              </PrimaryButton>
            </div>
          </div>
        </Panel>
      </LargeTile>
    </>
  );
};

export const RechargeConfirmationPage = () => {
  return <WideLayout outlet={MainPanels()}></WideLayout>;
};
